import { Customer } from '~/lib/api/smartsend/types';
export const DefaultExcludedServiceTags = ['SmartSendExclude'];
export const FavouriteIncludeServiceTags = ['SmartSendFavourite'];

export type CurrentSelectionType = {
  limitToAccount: boolean;
  accountId: string;
  id: string;
  provider: string;
  extras: string[];
  marketplaceService: string;
  sender: Customer;
  recipient: Customer;
};

export type DefaultQuoteRequestType = {
  provider: string;
  accountId: string;
  includeTags: string[];
  excludeTags: string[];
  sender: Customer;
  recipient: Customer;
};
